import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { ResponseCatalog, RequestParams } from 'Models'
import { InterfaceElementModel, RoleInterfaceElementModel } from 'Pages/interfaceElement'
import { NavConfigItem } from 'Modules'
import { Id } from 'Types/aliases'

export const interfaceElementsApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<InterfaceElementModel>>(
			urls.interface_element.index,
			{
				params,
			}
		)
		return res.data
	},
	createOne: async (data: InterfaceElementModel) => {
		const res = await axiosDS().post(urls.interface_element.index, { data })
		return res.data
	},
	updateOne: async (data: InterfaceElementModel, id: Id) => {
		const res = await axiosDS().patch(`${urls.interface_element.index}/${id}`, { data })
		return res.data
	},
	deleteOne: async (id: Id) => {
		const res = await axiosDS().delete(`${urls.interface_element.index}/${id}`)
		return res.data
	},
	getAllRole: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<InterfaceElementModel>>(
			urls.interface_element.role_interface,
			{ params }
		)
		return res.data
	},
	createRole: async (data: RoleInterfaceElementModel) => {
		const res = await axiosDS().post(urls.interface_element.role_interface, { data })
		return res.data
	},
	updateRole: async (data: RoleInterfaceElementModel, id: Id) => {
		const res = await axiosDS().patch(`${urls.interface_element.role_interface}/${id}`, { data })
		return res.data
	},
	deleteRole: async (id: Id) => {
		const res = await axiosDS().delete(`${urls.interface_element.role_interface}/${id}`)
		return res.data
	},
	getInterfaceElementAvailable: async () => {
		const res = await axiosDS().get<ResponseCatalog<NavConfigItem>>(
			urls.interface_element.available
		)
		return res.data
	},
	sendMenuSectionId: async (interface_element_id: Id) => {
		const res = await axiosDS().post(urls.statistics.create, {
			data: { interface_element_id },
		})
		return res.data
	},
}
